import React from 'react'
import { ReactComponent as EditSvg } from 'app/livbrite/resources/svg/edit.svg'
import { Question } from 'hooks/productSelector'
import { Container, Item } from './components/Styled'

interface Props {
  questions: Question[]
  stepBack: (answer: any) => void
}

export const Summary: React.FC<Props> = ({ questions, stepBack }) => {
  return (
    <Container>
      <h3>
        Did we get everything right?
      </h3>
      <ul>
        {questions.map((question: Record<string, any>) => {
          return (
            <Item key={question.id} onClick={() => stepBack(question)}>
              <p>
                {`${question.title}: `}
                <strong>
                  {question.answers?.map((answer: any) => {
                    const { label, value } = answer
                    const textQuestion = question.type === 'text'
                    return !textQuestion ? label : `${label}: ${value}`
                  }).join(', ')}
                </strong>
              </p>
              <EditSvg />
            </Item>
          )
        })}
      </ul>
    </Container>
  )
}
